import Pools from 'views/Pools'

const EarnPage = () => {
    return <Pools />
}

export default EarnPage